import { canonicalizeSelectValue, expandSelectChoices } from '@/utils/selectChoices';

/**
 * Include stored persona value(s) in a single_select option list so values
 * survive attribute type / choice changes and remain selectable in the UI.
 */
export function mergeSelectChoicesWithValue(choices, value) {
  const base = expandSelectChoices(choices);
  if (value === null || value === undefined || value === '') {
    return base;
  }

  const values = Array.isArray(value) ? value : [value];
  const seen = new Set(base.map((choice) => String(choice).toLowerCase()));
  const merged = [...base];

  values.forEach((entry) => {
    const text = String(entry ?? '').trim();
    if (!text || seen.has(text.toLowerCase())) return;
    merged.push(text);
    seen.add(text.toLowerCase());
  });

  return merged;
}

/**
 * Format a stored value for read-only display according to the current schema type.
 */
export function formatAttributeDisplayValue(value, attr) {
  if (value === null || value === undefined || value === '') return value;
  if (Array.isArray(value)) {
    return value.length ? value.join(', ') : '';
  }

  if (attr?.type === 'single_select') {
    return canonicalizeSelectValue(value, expandSelectChoices(attr.options?.choices));
  }

  if (attr?.type === 'number' && typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return value;
    const num = Number(trimmed);
    if (!Number.isNaN(num)) return num;
  }

  return value;
}
